// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"8534e917","670":"c5fe78e6","837":"7654ec01"}[chunkId] + ".chunk.js";
};